import React, { Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationItem from './NavigationItem';

import { ChevronDown } from '../icons';
import './NavigationDropdown.css';

function NavigationDropDown(props) {
  const {
    items,
    navigationTitle,
    expanded,
    expandHandler,
    itemType,
    parentSlug,
    currentModule,
    currentDischargeStep,
    currentLesson
  } = props;

  return (
    <Fragment>
      <div
        className={classNames(
          'dropdown-navigation',
          {
            'dropdown-navigation--open': expanded
          },
          itemType
        )}
      >
        <button
          className={classNames('dropdown-navigation__title', {
            'dropdown-navigation__title--open': expanded
          })}
          onClick={() => expandHandler()}
        >
          <span className="dropdown-navigation__title-text">
            {navigationTitle}
          </span>
          <ChevronDown width="32" height="32" viewBox="0 0 32 32" />
        </button>

        <div
          className={classNames('dropdown-navigation__panel', {
            'dropdown-navigation__panel--open': expanded
          })}
        >
          <ul className="dropdown-navigation__list">
            {currentModule && (
              <li className="dropdown-navigation__list-item__parent-content">
                <button onClick={() => expandHandler()}>
                  <NavigationItem
                    parentSlug={parentSlug}
                    itemType="module"
                    module={currentModule}
                    isParentContent
                    displayProgressIcon
                  />
                </button>
              </li>
            )}

            {currentModule &&
              currentModule.acf.pages.length > 0 &&
              currentModule.acf.pages.map(page => (
                <li className="dropdown-navigation__list-item" key={page.ID}>
                  <button onClick={() => expandHandler()}>
                    <NavigationItem
                      parentSlug={parentSlug}
                      itemType="chapter-intro-page"
                      module={currentModule}
                      chapterIntroPage={page}
                      isParentContent={false}
                      displayProgressIcon={false}
                    />
                  </button>
                </li>
              ))}

            {currentDischargeStep && (
              <li className="dropdown-navigation__list-item__parent-content">
                <button onClick={() => expandHandler()}>
                  <NavigationItem
                    parentSlug={parentSlug}
                    itemType="discharge"
                    module={currentDischargeStep}
                    isParentContent
                    displayProgressIcon={false}
                  />
                </button>
              </li>
            )}

            {currentLesson && (
              <li className="dropdown-navigation__list-item__parent-content">
                <button onClick={() => expandHandler()}>
                  <NavigationItem
                    parentSlug={parentSlug}
                    itemType="lesson-topics-nav"
                    module={currentLesson}
                    isParentContent
                    displayProgressIcon={false}
                  />
                </button>
              </li>
            )}

            {_.sortBy(items, 'menu_order').map(item => (
              <li className="dropdown-navigation__list-item" key={item.ID}>
                <button onClick={() => expandHandler()}>
                  <NavigationItem
                    parentSlug={parentSlug}
                    itemType={itemType}
                    module={item}
                    progress={item.completion}
                    itemTitle={itemType}
                    isParentContent={false}
                    displayProgressIcon
                  />
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Fragment>
  );
}

NavigationDropDown.defaultProps = {
  items: [],
  parentSlug: '',
  currentModule: null,
  currentDischargeStep: null,
  currentLesson: null
};

NavigationDropDown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      ID: PropTypes.number,
      completion: PropTypes.number
    })
  ),
  navigationTitle: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  expandHandler: PropTypes.func.isRequired,
  itemType: PropTypes.string.isRequired,
  parentSlug: PropTypes.string,
  currentModule: PropTypes.shape({
    acf: PropTypes.shape({
      pages: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }),
  currentDischargeStep: PropTypes.shape({}),
  currentLesson: PropTypes.shape({})
};

export default NavigationDropDown;



// WEBPACK FOOTER //
// ./src/components/NavigationDropdown/NavigationDropdown.js